exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main-nav{background:#edf4f6;font-size:14px;font-weight:700;padding:9px 30px 30px 0\n}\n.main-nav a{border-bottom:1px solid #d5dde2;display:block;padding:40px 0\n}\n.main-nav img{display:inline;margin-right:5px;transform:translateY(-1px);vertical-align:middle\n}\n@media (max-width:599px){\n.main-nav{display:table;margin:0 0 20px -20px;padding:0;text-align:center;width:calc(100% + 40px)\n}\n.main-nav img{display:block;margin:0 auto;width:19px\n}\n.main-nav a{display:table-cell;padding:10px 5px\n}\n}", ""]);

// exports
